/**
 * Centralized API Configuration
 * Provides consistent base URL configuration for all API services
 */

/**
 * Get the base URL for API calls
 * @returns {string} The base URL
 */
export const getApiBaseUrl = () => {
  // Check for environment variable first
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  return envUrl;
};
